import { BrowserRouter } from 'react-router-dom';

import ThemeProvider from './theme';
import Router from './routes/StyledRoutes';
import { toastOptions } from './services/SnackbarService';
import { Toaster } from 'react-hot-toast';
import { AuthContextProvider } from './store/auth-context';
import { PermissionContextProvider } from './store/permission-context';
import { SpinContextProvider } from './store/spin-context';
import { useState } from 'react';
const App = () => {
  return (
    <div>
      <AuthContextProvider>
        <PermissionContextProvider>
          <SpinContextProvider>
            <BrowserRouter>
              <ThemeProvider>
                <Toaster key='toaster' {...{ toastOptions }} />
                <Router />
              </ThemeProvider>
            </BrowserRouter>
          </SpinContextProvider>
        </PermissionContextProvider>
      </AuthContextProvider>
    </div>
  );
}

export default App;
